export default [
  {
    value: 'Home',
    url: 'index'
  },
  {
    value: 'Stations',
    url: 'station'
  },
  {
    value: 'About',
    url: 'about'
  }
]
